import React from 'react';
import { Grid, TextField, Autocomplete, Box } from '@mui/material';
import { FormSection, SectionTitle, FieldRow, FieldTitle, StyledPopper } from './StyledComponents';

const SortingCodesSection = ({
    direction,
    t,
    formData,
    handleInputChange,
    validationErrors,
    sortCodeIdOptions,
    showPdfIframe,
    uploadedDocumentUrl
}) => {
    return (
        <FormSection>
            <SectionTitle dir={direction}>{t('SortingCodes')}</SectionTitle>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('Manifest')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Autocomplete
                            options={sortCodeIdOptions || []}
                            getOptionLabel={(option) =>
                                `${option.sortCodeId} - ${option.sortCodeName}`
                            }
                            value={
                                sortCodeIdOptions?.find(
                                    (option) => option.sortCodeId === formData.manifest
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                const newManifestId = newValue ? newValue.sortCodeId : '';
                                handleInputChange('manifest', newManifestId);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={t('Manifest')}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                        sx: {
                                            height: '42px',
                                            width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                            padding: '0 10px',
                                            borderRadius: '8px',
                                            background: '#F5F5F6',
                                            border: !formData.manifest ? '2px solid #E53E3E' : '1px solid transparent',
                                            '&:focus-within': {
                                                border: !formData.manifest ? '2px solid #E53E3E' : '2px solid #304FFF',
                                            },
                                        },
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        style: {
                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                        },
                                    }}
                                    required
                                    error={!!validationErrors.manifest}
                                    helperText={validationErrors.manifest}
                                />
                            )}
                            PopperComponent={(props) => (
                                <StyledPopper
                                    {...props}
                                    style={{
                                        ...props.style,
                                        direction: direction,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                    }}
                                />
                            )}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('LiableExpenses')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Autocomplete
                            options={sortCodeIdOptions || []}
                            getOptionLabel={(option) =>
                                `${option.sortCodeId} - ${option.sortCodeName}`
                            }
                            value={
                                sortCodeIdOptions?.find(
                                    (option) => option.sortCodeId === formData.liableExpenses
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                const newLiableExpensesId = newValue ? newValue.sortCodeId : '';
                                handleInputChange('liableExpenses', newLiableExpensesId);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={t('LiableExpenses')}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                        sx: {
                                            height: '42px',
                                            width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                            padding: '0 10px',
                                            borderRadius: '8px',
                                            background: '#F5F5F6',
                                            border: !formData.liableExpenses ? '2px solid #E53E3E' : '1px solid transparent',
                                            '&:focus-within': {
                                                border: !formData.liableExpenses ? '2px solid #E53E3E' : '2px solid #304FFF',
                                            },
                                        },
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        style: {
                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                        },
                                    }}
                                    required
                                    error={!!validationErrors.liableExpenses}
                                    helperText={validationErrors.liableExpenses}
                                />
                            )}
                            PopperComponent={(props) => (
                                <StyledPopper
                                    {...props}
                                    style={{
                                        ...props.style,
                                        direction: direction,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                    }}
                                />
                            )}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>
                            {t('ExemptExpenses')}
                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                        </FieldTitle>
                        <Autocomplete
                            options={sortCodeIdOptions || []}
                            getOptionLabel={(option) =>
                                `${option.sortCodeId} - ${option.sortCodeName}`
                            }
                            value={
                                sortCodeIdOptions?.find(
                                    (option) => option.sortCodeId === formData.exemptExpenses
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                const newExemptExpensesId = newValue ? newValue.sortCodeId : '';
                                handleInputChange('exemptExpenses', newExemptExpensesId);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={t('ExemptExpenses')}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                        sx: {
                                            height: '42px',
                                            width: showPdfIframe && uploadedDocumentUrl ? "170px" : "230px",
                                            padding: '0 10px',
                                            borderRadius: '8px',
                                            background: '#F5F5F6',
                                            border: !formData.exemptExpenses ? '2px solid #E53E3E' : '1px solid transparent',
                                            '&:focus-within': {
                                                border: !formData.exemptExpenses ? '2px solid #E53E3E' : '2px solid #304FFF',
                                            },
                                        },
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        style: {
                                            textAlign: direction === 'ltr' ? 'left' : 'right',
                                        },
                                    }}
                                    required
                                    error={!!validationErrors.exemptExpenses}
                                    helperText={validationErrors.exemptExpenses}
                                />
                            )}
                            PopperComponent={(props) => (
                                <StyledPopper
                                    {...props}
                                    style={{
                                        ...props.style,
                                        direction: direction,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.7)',
                                    }}
                                />
                            )}
                        />
                    </FieldRow>
                </Grid>
            </Grid>
        </FormSection>
    );
};

export default SortingCodesSection;